export default "__VITE_ASSET__5MnsTnUe__"